import React, { useState } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

// Components
import TextInput from "new_components/molecules/TextInput";
import TextEditor from "new_components/organisms/TextEditor";
import Text from "new_components/atoms/Text";
import Tabs from "new_components/molecules/Tabs";

// Constants
import colors from "styles/colors";
import typography from "styles/typography";

const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 8px;
`;

const EmailTemplate = ({ emailTemplate, onUpdate, errors }) => {
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const handleEmailChange = (field, value) => {
    onUpdate({ ...emailTemplate, [field]: value });
  };

  const tabs = [
    {
      label: "English",
      content: (
        <SectionWrapper>
          <InputWrapper>
            <TextInput
              label="Email Subject"
              value={emailTemplate?.email_subject || ""}
              onChange={(value) => handleEmailChange("email_subject", value)}
              error={errors?.emailSubjectValidation}
            />
          </InputWrapper>
          <TextEditor
            value={emailTemplate?.email_content || ""}
            onChange={(value) => handleEmailChange("email_content", value)}
            hasError={errors?.emailBodyValidation}
          />
          {errors?.emailBodyValidation && (
            <Text
              color={colors.auxiliary.red[500]}
              typographyStyle={typography.smallText.regular}
            >
              {errors.emailBodyValidation}
            </Text>
          )}
        </SectionWrapper>
      )
    },
    {
      label: "French *",
      content: (
        <SectionWrapper>
          <TextEditor
            value={emailTemplate?.email_content_fr || ""}
            onChange={(value) => handleEmailChange("email_content_fr", value)}
            hasError={errors?.emailBodyFrValidation}
          />
          {errors?.emailBodyFrValidation && (
            <Text
              color={colors.auxiliary.red[500]}
              typographyStyle={typography.smallText.regular}
            >
              {errors.emailBodyFrValidation}
            </Text>
          )}
        </SectionWrapper>
      )
    }
  ];

  return (
    <div>
      <Tabs 
        tabs={tabs}
        activeTabIndex={activeTabIndex}
        onTabChange={setActiveTabIndex}
      />
      {tabs[activeTabIndex].content}
    </div>
  );
};

EmailTemplate.propTypes = {
  emailTemplate: PropTypes.shape({
    email_subject: PropTypes.string,
    email_content: PropTypes.string,
    email_content_fr: PropTypes.string,
  }),
  onUpdate: PropTypes.func,
  errors: PropTypes.shape({
    emailSubjectValidation: PropTypes.string,
    emailBodyValidation: PropTypes.string,
    emailBodyFrValidation: PropTypes.string,
  }),
};

export default EmailTemplate;
